import React from 'react'
import { SVGIconProps } from '../types'
const SvgChain = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M5.618 4.845a5.6 5.6 0 0 0-.618.68 3.1 3.1 0 0 0-.5.975h-1a1.5 1.5 0 0 0-.144 2.993L3.5 9.5h4a1.5 1.5 0 0 0 1.493-1.356L9 8v-.6c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4V8a3.5 3.5 0 0 1-3.308 3.495L7.5 11.5h-4a3.5 3.5 0 0 1-.192-6.995L3.5 4.5h1.98a.2.2 0 0 1 .138.345" />
    <path d="M7 8.682V8a1.5 1.5 0 0 1 1.356-1.493L8.5 6.5h4a1.5 1.5 0 0 1 .144 2.993L12.5 9.5h-1q-.108.499-.5 1.02-.246.33-.579.632a.2.2 0 0 0 .135.348H12.5a3.5 3.5 0 0 0 .192-6.995L12.5 4.5h-4a3.5 3.5 0 0 0-3.495 3.308L5 8v.682c0 .221.18.4.4.4h1.2a.4.4 0 0 0 .4-.4" />
  </svg>
)
export default SvgChain
